<template>
  <div class="h-full p-10px text-14px">
    <div class="flex justify-between">
      <div>
        <span>数据标准库：</span
        ><el-select v-model="standardId" filterable placeholder="请选择标准库"></el-select>
      </div>
      <div>
        <span>统计周期：</span>
        <el-radio-group v-model="cycle">
          <el-radio label="0">今日</el-radio>
          <el-radio label="1">昨日</el-radio>
          <el-radio label="2">本周</el-radio>
          <el-radio label="3">本月</el-radio>
          <el-radio label="4">本年</el-radio>
        </el-radio-group>
      </div>
    </div>
    <el-row :gutter="20" class="h-100px mt-20px">
      <el-col :span="6" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="flex justify-between h-full">
            <div class="w-200px h-full">
              <div class="font-bold text-16px">数据源总数（个）</div>
              <div class="text-24px mt-10px">2056</div>
            </div>
            <div class="flex-1 h-full"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="flex justify-between h-full">
            <div class="w-200px h-full">
              <div class="font-bold text-16px">数据采集任务总数（个）</div>
              <div class="text-24px mt-10px">2056</div>
            </div>
            <div class="flex-1 h-full"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="flex justify-between h-full">
            <div class="w-200px h-full">
              <div class="font-bold text-16px">数据采集数据总量（GB）</div>
              <div class="text-24px mt-10px">2056</div>
            </div>
            <div class="flex-1 h-full"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="flex justify-between h-full">
            <div class="w-200px h-full">
              <div class="font-bold text-16px">数据采集数据总数（万条）</div>
              <div class="text-24px mt-10px">2056</div>
            </div>
            <div class="flex-1 h-full"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="h-200px mt-20px">
      <el-col :span="8" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
          <div class="h-24px mb-10px font-bold">任务状态占比分析</div>
          <div class="h-[calc(100%-34px)]">
            <v-chart
              :options="taskStatusOptions"
              autoresize
              class="w-full h-full"
              ref="taskStatus"
            ></v-chart>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
          <div class="h-24px mb-10px font-bold">实体对象采集状态占比分析</div>
          <div class="h-[calc(100%-34px)]">
            <v-chart
              :options="taskStatusOptions"
              autoresize
              class="w-full h-full"
              ref="taskStatus"
            ></v-chart>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
          <div class="h-24px mb-10px font-bold">采集任务状态占比分析</div>
          <div class="h-[calc(100%-34px)]">
            <v-chart
              :options="taskStatusOptions"
              autoresize
              class="w-full h-full"
              ref="taskStatus"
            ></v-chart>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="h-[calc(100%-376px)] mt-20px">
      <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
        <div class="font-bold">各时段采集任务分布图</div>
        <div class="h-[calc(100%-34px)] mt-20px flex">
          <v-chart
            :options="periodsOptions"
            autoresize
            class="flex-1 h-full"
            ref="periods"
          ></v-chart>
          <div class="w-200px h-full">
            <div class="h-1/2">
              <div class="text-[#999]">采集成功总数（个）</div>
              <div class="text-30px mt-10px mb-30px">140</div>
              <div class="text-[#999]">
                自从上周以来<span class="text-[#00a870]">下降20.5%</span>
              </div>
            </div>
            <div class="h-1/2">
              <div class="text-[#999]">采集失败总数（个）</div>
              <div class="text-30px mt-10px mb-30px">140</div>
              <div class="text-[#999]">
                自从上周以来<span class="text-[#00a870]">下降20.5%</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'monitor',
  data() {
    return {
      standardId: '',
      cycle: '0',
      taskStatusData: [
        { value: 100, name: '已完成' },
        { value: 200, name: '未运行' },
        { value: 300, name: '已停止' },
        { value: 400, name: '停止中' },
        { value: 500, name: '已报错' },
        { value: 600, name: '运行中' },
      ],
      taskStatusOptions: {
        color: ['#3aa0ff', '#36cbcb', '#00a870', '#ed7b2f', '#f2637b', '#975fe4'],
        tooltip: { trigger: 'item' },
        legend: {
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          right: '6%',
          orient: 'vertical',
          formatter: (name) => {
            const item = _.find(this.taskStatusData, { name })
            return `${item.name} | ${item.percent}%            ${item.value}`
          },
        },
        title: {
          show: true,
          text: '总数',
          subtext: 0,
          top: '35%',
          left: '20%',
          textAlign: 'center',
          textStyle: {
            color: '#949494',
            fontSize: '12',
          },
          subtextStyle: {
            fontSize: '16',
            color: '#000',
          },
        },
        series: [
          {
            name: '任务状态占比分析',
            type: 'pie',
            radius: ['80%', '100%'],
            center: ['20%', '50%'],
            avoidLabelOverlap: false,
            left: '0%',
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      }, // 任务状态占比分析
      periodsOptions: {
        color: ['#00a870', '#bcc4d0'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '采集成功',
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            stack: 'total',
          },
          {
            name: '采集失败',
            data: [20, 10, 50, 20, 10, 30, 80],
            type: 'bar',
            stack: 'total',
          },
        ],
      }, // 各时段采集任务分布图
    }
  },
  methods: {
    // 处理图例
    handleLegend(data) {
      let sum = 0
      data.forEach((item) => {
        sum = sum + item.value
      })
      _.map(data, (item) => {
        item.percent = ((item.value / sum) * 100).toFixed(2)
        return item
      })
      return sum
    },
  },
  created() {
    this.taskStatusOptions.title.subtext = this.handleLegend(this.taskStatusData)
    this.taskStatusOptions.series[0].data = this.taskStatusData
  },
}
</script>
